import { render } from "./OrderListPage.vue?vue&type=template&id=1e1c201b"
import script from "./OrderListPage.vue?vue&type=script&lang=js"
export * from "./OrderListPage.vue?vue&type=script&lang=js"
script.render = render

export default script